import type { CancelablePromise } from "./core/CancelablePromise"
import { OpenAPI } from "./core/OpenAPI"
import { request as __request } from "./core/request"

let __publicKeyCache: string | null = null

/**
 * SecurityService provides methods for security-related public endpoints.
 */
export class SecurityService {
  /**
   * Fetch server public key (PEM) used for token verification.
   * GET /v1/crypto/public-key
   */
  public static getPublicKey(): CancelablePromise<string> {
    return __request<string>(OpenAPI, {
      method: "GET",
      url: "/v1/crypto/public-key",
      // Ask for text/PEM back; backend returns application/x-pem-file
      headers: {
        Accept: "application/x-pem-file, text/plain, */*",
      },
      responseType: "text",
    })
  }
}

/**
 * Convenience helper with simple in-memory caching for the current session.
 * Pass forceRefresh=true to re-fetch.
 */
export const getCachedPublicKey = async (
  forceRefresh = false,
): Promise<string> => {
  if (!forceRefresh && __publicKeyCache) return __publicKeyCache
  const pem = await SecurityService.getPublicKey()
  __publicKeyCache = pem
  return pem
}
